import React, { useEffect, useRef, useState } from "react";
import useOutSideClick from "../../common/useOutSideClick";
import styled from "styled-components";
import ModalContainer from "../ModalContainer";

function PCModal({ title, onClose, children }) {
  const modalRef = useRef(null)
  const handleClose = () => {
    onClose?.();
  };

  useEffect(() => {
    // Mount 될때만 실행된다.
    const $body = document.querySelector("body");
    const overflow = $body.style.overflow;
    $body.style.overflow = "hidden";
    return () => {
    	$body.style.overflow = overflow
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' || event.keyCode === 27) {
        // SelectModal이 열려 있으면 메인 모달은 닫지 않음 (z-index: select 16 > main 15)
        const hasOpenSelectModal = document.querySelector('.in_select_modal') !== null;
        if (!hasOpenSelectModal) {
          onClose?.();
        }
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  useOutSideClick(modalRef, handleClose);

  return (
    <ModalContainer>
      <Overlay>
        <ModalWrap ref={modalRef} className="in_modal">
          <TitleWrap>{title}</TitleWrap>
          <Contents>
            {children}
          </Contents>
          {/*
          <div className="swal2-container swal2-center swal2-backdrop-show" style={{ overflowY: 'auto'}}>
            <div aria-labelledby="swal2-title" aria-describedby="swal2-html-container" className="swal2-popup swal2-modal swal2-icon-error swal2-show" role="dialog" aria-live="assertive" aria-modal="true" style={{ display: 'grid'}}>
              <div className="swal2-icon swal2-error swal2-icon-show" style={{ display: 'flex'}}><span className="swal2-x-mark">
                      <span className="swal2-x-mark-line-left"></span>
                      <span className="swal2-x-mark-line-right"></span>
                  </span>
              </div>
              <div className="swal2-html-container" id="swal2-html-container" style={{ display: 'block'}}>
                아이디와 비밀번호를 다시 확인해주세요.
              </div>
              
              <div className="swal2-actions" style={{ display: 'flex'}}>
                  <div className="swal2-loader"></div>
                  <button type="button" className="swal2-confirm swal2-styled" aria-label="" style={{ display: 'inline-block'}}>확인</button>
              </div>
              <div className="swal2-timer-progress-bar-container">
              </div>
            </div>
          </div>
          */}
        </ModalWrap>
      </Overlay>
    </ModalContainer>
  );
}

const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 15;
`;

const ModalWrap = styled.div`
  max-width: 1025px;
  height: fit-content;
  border-radius: 10px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Contents = styled.div`
  margin: 0px;
  h1 {
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 60px;
  }
  img {
    margin-top: 60px;
    width: 300px;
  }
`;
const TitleWrap = styled.div`
  width: 100%;
  padding: 10px 20px 12px;
  box-sizing: border-box;
  font-size: 26px;
  font-weight: bold;
`;
const Button = styled.button`
  font-size: 14px;
  padding: 10px 20px;
  border: none;
  background-color: #ababab;
  border-radius: 10px;
  color: white;
  font-style: italic;
  font-weight: 200;
  cursor: pointer;
  &:hover {
    background-color: #898989;
  }
`;
export default PCModal;
